export ProjectsList = '''
	name
	id
	slug
	city
	country
	branch
	photo {
		original
	}
'''
